var isNil = require('./isNil');
var isString = require('./isString');

module.exports = function isTypeName(name) {
  return isNil(name) || isString(name);
};


//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/tcomb/lib/isTypeName.js
// module id = 121
// module chunks = 69